import { Link } from "react-router-dom";
import type { Actress } from "@/mocks/actresses";

interface ActressCardProps {
  actress: Actress;
}

export default function ActressCard({ actress }: ActressCardProps) {
  return (
    <Link
      to={`/detail/actress/${actress.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-200">
        <div className="aspect-[3/4] w-full">
          <img
            src={actress.portrait}
            alt={`${actress.name} 女优资料写真`}
            title={`${actress.name} 日本女优资料与影视作品`}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
          />
        </div>
        <span
          className={`absolute left-3 top-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 font-label text-[11px] ${
            actress.status === "活跃"
              ? "bg-accent-500 text-foreground-950"
              : "bg-secondary-500/90 text-background-50"
          }`}
        >
          <i className={actress.status === "活跃" ? "ri-pulse-line" : "ri-pause-line"} aria-hidden="true"></i>
          {actress.status}
        </span>
        <span className="absolute bottom-3 right-3 rounded-full bg-foreground-950/70 px-2.5 py-1 font-label text-[11px] text-background-50">
          {actress.worksCount} 部作品
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-baseline justify-between gap-2">
          <h3 className="font-heading text-lg font-bold leading-tight text-foreground-950">
            {actress.name}
          </h3>
          <span className="font-label text-[11px] uppercase tracking-wide text-foreground-400">
            {actress.nameRomaji}
          </span>
        </div>
        <p className="mt-1 font-label text-xs text-foreground-500">
          {actress.age} 岁 · {actress.debutYear} 年出道 · {actress.agency}
        </p>
        <p className="clamp-2 mt-2 text-sm leading-relaxed text-foreground-700">{actress.bio}</p>
        <div className="mt-auto flex flex-wrap gap-1.5 pt-4">
          {actress.featuredWorks.slice(0, 2).map((title) => (
            <span
              key={title}
              className="inline-flex items-center gap-1 rounded-md bg-secondary-100 px-2 py-1 font-label text-[11px] text-secondary-900"
            >
              <i className="ri-film-line" aria-hidden="true"></i>
              {title}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}